import { CommonResponse, ID } from '@xver/@types/api';
import {
    FirewallSecurityGroupMetadataBase,
    FirewallSecurityGroupResponse,
} from '@xver/@types/firewall-security-group';
import { Pagination, PaginationQueryParams } from '@xver/@types/pagination';
import httpClient from '@xver/libs/axios';

const ENDPOINTS = {
    LIST: '/v1/firewalls/security-groups',
    CREATE: '/v1/firewalls/security-groups',
    BATCH_DELETE: '/v1/firewalls/security-groups/batch-delete',
    UPDATE: (id: string | number) => `/v1/firewalls/security-groups/${id}`,
    DELETE: (id: string) => `/v1/firewalls/security-groups/${id}`,
};

export function listSecurityGroups(
    query: PaginationQueryParams
): Promise<Pagination<FirewallSecurityGroupResponse>> {
    return httpClient.get(ENDPOINTS.LIST, { params: query });
}

export function createSecurityGroup(
    body: FirewallSecurityGroupMetadataBase
): Promise<FirewallSecurityGroupResponse> {
    return httpClient.post(ENDPOINTS.CREATE, body);
}

export function batchDeleteSecurityGroups(ids: string[]): Promise<CommonResponse> {
    return httpClient.delete(ENDPOINTS.BATCH_DELETE, { data: { ids } });
}

export function updateSecurityGroup(
    body: ID & FirewallSecurityGroupMetadataBase
): Promise<CommonResponse> {
    return httpClient.put(ENDPOINTS.UPDATE(body.id), body);
}

export function deleteSecurityGroup(id: string): Promise<CommonResponse> {
    return httpClient.delete(ENDPOINTS.DELETE(id));
}
